import React from "react";

// Per-question save indicator for the Review & Submit step (see useReviewAutoSave). A failed save
// leaves the change in place and still sends it on Submit, so the error offers a retry rather
// than blocking — except a 409 (the assessment is read-only after final submit), where neither a
// retry nor Submit will store it, so the server's reason is shown instead.
const ReviewSaveStatus = ({ status, error, onRetry }) => {
    if (status === "saving") {
        return <span className="text-xs text-gray-500" role="status">Saving…</span>;
    }
    if (status === "saved") {
        return <span className="text-xs text-green-700" role="status">Saved</span>;
    }
    if (status === "error") {
        if (error?.response?.status === 409) {
            return (
                <span className="text-xs text-red-700" role="alert">
                    {error.response.data?.message || "This assessment has been submitted and is read-only."}
                </span>
            );
        }
        return (
            <span className="text-xs text-red-700" role="alert">
                Couldn't save this change. It will be saved when you submit.{" "}
                <button type="button" onClick={onRetry} className="underline font-medium">
                    Retry
                </button>
            </span>
        );
    }
    return null;
};

export default ReviewSaveStatus;
